export default [
    {
        title: 'Operación de edificios',
        subtitle: 'Nuestro servicio integra un conjunto de especialidades que nos permiten operar de manera  optima los inmuebles.',
        list: [
            'Soporte en infraestructura de misión crítica',
            "Suministro / sutitución de equipamiento",
            "Commissioning",
            "Trámites CFE / UVIE",
            "Supervisión de obrea",
            "Sistemas de seguridad",
            "Reubicaciones / expansiones / reducciones"
        ],
        expanded: false,
    },
    {
        title: 'Construcción ligera y remodelación',
        subtitle: 'Te ayudamos a construir y a crear espacios idóneos para ti y tu empresa.',
        list: [
            'Construcción ligera residencial, comercial y de oficinas',
            "Remodelación residencial, comercial y de oficinas",
            "Cambio de imagen",
            "Instalaciones hidrosanitarias y eléctricas",
            "Aire acondicionado",
            "Cableado estructurado",
            "Sistemas de seguridad"
        ],
        expanded: false
    },
    {
        title: 'Facilities',
        subtitle: 'Te ofrecemos las soluciones indicadas para resolver las necesidades de mantenimiento de las instalaciones de tus inmuebles'
    },
    {
        title: 'Gestión inmobiliaria',
        subtitle: 'Te apoyamos con la venta o arrendamiento de cualquier inmueble, también de ayudamos a localizar espacios.'
    },
    {
        title: 'Diagnósticos energéticos',
        subtitle: 'Te ofrecemos estrategias para mejorar las prácticas de consumo energético con la finalidad de eficientar y apovechar el consumo de este recurso.',
        button: 'Ver presentación',
        link: '/energy.pptx',
        target: '_blank'
    },
    {
        title: 'Regreso a la Nueva normalidad',
        subtitle: 'Ofrecemos servicios de desinfección y sanitización para facilitar el regreso a la “Nueva Normalidad”.',
        button: 'Ver presentación',
        link: '/regreso-a-oficina.pdf',
        target: '_blank'
    },
]